var map = {
	"./call-procedure/open-close-valve": [
		6559,
		559
	],
	"./call-procedure/open-close-valve.tsx": [
		6559,
		559
	],
	"./call-procedure/sync-transmitter": [
		2888,
		888
	],
	"./call-procedure/sync-transmitter.tsx": [
		2888,
		888
	],
	"./call-procedure/visual-test": [
		6304,
		304
	],
	"./call-procedure/visual-test.tsx": [
		6304,
		304
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2695;
module.exports = webpackAsyncContext;